/** Round $/gal for API JSON so binary floats do not break DecimalField(decimal_places=4). */
export function roundPricePerLiterForApi(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return NaN;
  return parseFloat(x.toFixed(4));
}

/** Display fuel price per gallon with up to 4 decimal places. */
export function formatPricePerGallon(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return '—';
  return x.toFixed(4);
}

/**
 * Manager UI: tax entered as percent (e.g. 8.25). Empty → 0.
 * @returns {{ ok: true, value: number } | { ok: false, message: string }}
 */
export function taxPercentInputToDecimal(input) {
  if (input === null || input === undefined) return { ok: true, value: 0 };
  const s = String(input).trim();
  if (s === '') return { ok: true, value: 0 };
  const pct = parseFloat(s);
  if (!Number.isFinite(pct) || pct < 0 || pct > 100) {
    return { ok: false, message: 'Tax rates must be valid percentages between 0 and 100.' };
  }
  const dec = Math.round((pct / 100) * 10000) / 10000;
  return { ok: true, value: parseFloat(dec.toFixed(4)) };
}

/**
 * Some deployed APIs still require diesel_price_per_gallon / def_price_per_gallon on write.
 * UI is always $/gal; send the same numbers under both names so liter-only serializers ignore extras.
 */
export function addLegacyGallonPriceAliases(payload) {
  if (!payload || typeof payload !== 'object') return payload;
  if (payload.diesel_price_per_liter !== undefined) {
    payload.diesel_price_per_gallon = payload.diesel_price_per_liter;
  }
  if (payload.def_price_per_liter !== undefined) {
    payload.def_price_per_gallon = payload.def_price_per_liter;
  }
  return payload;
}

/** Normalize API row whether backend exposes *_per_liter or legacy *_per_gallon. */
export function normalizePricingRow(row) {
  if (!row || typeof row !== 'object') return row;
  return {
    ...row,
    diesel_price_per_liter: row.diesel_price_per_liter ?? row.diesel_price_per_gallon,
    def_price_per_liter: row.def_price_per_liter ?? row.def_price_per_gallon,
  };
}
